export enum EEpilepsyType {
  IdiopathicGeneralizedEpilepsyAbsence = '2',
  IdiopathicGeneralizedEpilepsyMyoclonic = '3',
  IdiopathicGeneralizedEpilepsyTonicClonic = '1',
  SymptomaticFocalEpilepsyComplexPartial = '5',
  SymptomaticFocalEpilepsySecondarilyGeneralizedPartial = '6',
  SymptomaticFocalEpilepsySimplePartial = '4',
  SymptomaticGeneralizedEpilepsyAbsence = '8',
  SymptomaticGeneralizedEpilepsyMyoclonic = '9',
  SymptomaticGeneralizedEpilepsyTonicClonic = '7',
}

export enum EPatientType {
  Elderly = '2',
  Other = '1',
  PatientWithDepression = '5',
  PatientWithMentalImpairment = '6',
  Pregnant = '4',
  WomanNotPregnant = '3',
}

export interface ICombination {
  drugs: string;
  observation: string;
  posologia: string;
  presentation: string;
}

export interface IFirstLineDrug {
  id: number;
  name: string;
}

export interface IGetDrugsInputData {
  epilepsyType: EEpilepsyType;
  patientType: EPatientType;
}

export interface IUseDrogasAntiEpileticas {
  combination: ICombination | null;
  epilepsyType: EEpilepsyType;
  firstLineDrugs: IFirstLineDrug[];
  onGetDrugs(inputData: IGetDrugsInputData): void;
  onSelectFirstLineDrug(name: string): void;
  patientType: EPatientType;
  selectedFirstLineDrug: IFirstLineDrug | null;
  setEpilepsyType(value: EEpilepsyType): void;
  setPatientType(value: EPatientType): void;
}
